import { lumi } from "@/lib/lumi"
import { useCallback, useEffect, useState } from "react"

type AuthUser = typeof lumi.auth.user

export function useAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(lumi.auth.isAuthenticated)
  const [user, setUser] = useState<AuthUser>(lumi.auth.user)

  useEffect(() => {
    const unsubscribe = lumi.auth.onAuthChange(({ isAuthenticated, user }) => {
      setIsAuthenticated(isAuthenticated)
      setUser(user)
    })
    return () => unsubscribe()
  }, [])

  const signIn = useCallback(async () => {
    try {
      await lumi.auth.signIn()
      setIsAuthenticated(lumi.auth.isAuthenticated)
      setUser(lumi.auth.user)
      return lumi.auth.user
    } catch (error) {
      console.error("Sign in failed:", error)
      throw error
    }
  }, [])

  const signOut = useCallback(async () => {
    try {
      await lumi.auth.signOut()
    } catch (error) {
      console.error("Sign out failed:", error)
      throw error
    }
  }, [])

  return {
    user,
    isAuthenticated,
    isAdmin: user?.userRole === "ADMIN",
    signIn,
    signOut,
  }
}
